var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ramucirumab"},[_c('div',{staticClass:"title",on:{"click":function($event){return _vm.open('newRamucirumab')}}},[_vm._v(" 雷其他获批本癌种药物提示 "),_c('i',{staticClass:"iconfont icon-right_medium",class:_vm.isOpen == false ? 'icon-right_medium' : 'icon-down_medium'})])])
}
var staticRenderFns = []

export { render, staticRenderFns }